import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'

interface invoiceParams{
  item_id:number[],
  invoice_date:string | null,
  invoice_date_due:string | null,
  currency:{} | null,
  exchanges:[],
  base:Object | null
}

interface journalEntryParams {
  item_id: number[],
  journal_entry_date: string | null,
  base: Object | null
}

interface noteCreditParams{
  item_id:number[],
  invoice_date:string | null,
  invoice_date_due:string | null
}

class BillingServices {
  async getBillingInfo(reservation_id:number, no_cache:boolean = false): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/billing/item/${reservation_id}`, {
        params:{no_cache},
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async invoiceItems(body:invoiceParams): Promise<any> {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/invoice/`,{
        ...body
      }, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async generateJournalEntryItems(body:journalEntryParams): Promise<any> {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/invoice/journal-entry/`, {
        ...body
      }, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async invalidateJournalEntryItem(journalEntryiId: number): Promise<any> {
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/invoice/cancel/journal-entry/${journalEntryiId}`, {
      }, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async creditNoteItems(body:noteCreditParams): Promise<any> {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/invoice/credit_note/`,{
        ...body
      }, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getDocuments(reservation_id:number): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/invoice/reservation/${reservation_id}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async invalidateDocument(invoice_id:number, reason:string): Promise<any> {
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/invoice/cancel/`,
        {
          invoice_id,
          reason
        },
        {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async refetchDocument(invoice_id:number): Promise<any> {
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/invoice/erp-system/${invoice_id}`, {},{
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async visualizeInvoice(body:invoiceParams): Promise<any> {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/invoice/visualize/`,
        body,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async visualizeInvoiceProvider(body:invoiceParams): Promise<any> {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/invoice/provider/visualize/`,
        body,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getBillingBases(): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/billing/bases/`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async retrySupplierBillingInvoice(supplier_billing_id : number): Promise<any> {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/invoice/provider/on-demand/${supplier_billing_id}`, {},{
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

}
export const billingServices = new BillingServices()